import React, { Component } from 'react'

import { isEmpty } from 'ramda'
import { Select } from '@driftt/tide'

import { connect } from 'react-redux'
import { getSyncedKnowledgebaseList, getBotDataSource, getBotConfigEnabled } from 'modules/settings/selectors'

import { setBotConfig } from 'modules/settings/actions'

import { bindActionCreators } from 'redux'

import './style.css'

const CONNECT_KNOWLEDGE_BASE_LINK='/settings/setup/knowledgebase'

class KnowledgeBaseSuggestions extends Component {

  state = {
    selectedSyncedKnowledgeBaseOption: ''
  }

  formatName = string => {
    const upperCaseString = string.charAt(0).toUpperCase() + string.slice(1);
    return upperCaseString.split(/(?=[A-Z])/).join(' ');
  }

  setBotConfig = selectedOptionValue => {
    const botConfigPayload = {
      enabled: this.props.isBotEnabled,
      botDatasource: selectedOptionValue.value
    }

    this.setState({
      selectedSyncedKnowledgeBaseOption: selectedOptionValue.value
    })

    this.props.setBotConfig(botConfigPayload)
  }

  renderDropDown() {

    let syncedKnowledgeBaseOptions

    syncedKnowledgeBaseOptions = this.props.syncedKnowledgeBaseList.map(kb => ({ value: kb, label: this.formatName(kb) }))

    return (
      <Select
        searchable={false}
        className="knowledge-base-dropdown"
        onChange={this.setBotConfig}
        options={syncedKnowledgeBaseOptions}
        clearable={false}
        value={(isEmpty(this.state.selectedSyncedKnowledgeBaseOption) && this.props.botDatasource) || this.state.selectedSyncedKnowledgeBaseOption}
        label={`Driftbot will surface articles from:`}
      />
    )
  }

  render() {
    const { syncedKnowledgeBaseList } = this.props

    return (
      <div>
        <div className="knowledge-base-dropdown-container">
          {!isEmpty(syncedKnowledgeBaseList) && this.renderDropDown()}
        </div>
        <p>
          <a className="connection-link" rel="noopener noreferrer"  href={CONNECT_KNOWLEDGE_BASE_LINK} target="_blank">Connect a different knowledge base</a>
        </p>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  syncedKnowledgeBaseList: getSyncedKnowledgebaseList(state),
  botDatasource: getBotDataSource(state),
  isBotEnabled: getBotConfigEnabled(state)
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    setBotConfig
  }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(KnowledgeBaseSuggestions)
